"use client";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getBondsListData } from "../api/service/homepage";
import BondsListing from "./components/bonds-listing";
import { useAuth } from "@/context/authcontext";
import { useRouter } from "next/navigation";
import { setRedirectTo } from "@/app/utils/helper";
import SharesSkeleton from "../components/loaders/shares-skeleton";

const Page = () => {

    const { isAuthenticated, isAuthFetched, isLoading } = useAuth();
    const router = useRouter();

    if (isAuthFetched && !isAuthenticated) {
        setRedirectTo(`${process.env.ICM_BONDS_URL}/platform`);
        router.push(`${process.env.ICM_BONDS_URL}/login`);
    }

        const {
            data: bondsData,
            // isFetched: isBondsFetched,
            isLoading: isBondsLoading,
        } = useQuery({
            queryKey: ["bondsListData"],
            queryFn: getBondsListData,
        });        

    if (isBondsLoading || isLoading) {
        return <SharesSkeleton/>
    }

    return (
        <div className="w-full" id="bonds-listing-page">
            <BondsListing bonds={bondsData?.data}/>
        </div>
    );
};

export default Page;